import styled, { css } from 'styled-components'

export const Paper = styled.div`
  background-color: ${({ theme }) => theme.colors.foregroundPaper};
  border-radius: 12px;
  gap: 10px;
  width: 100%;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
`

export const BoldText = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text};
`
export const Link = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.textLink};
`

export const RegularText = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};

  ${({ theme }) => css`
    font-family: ${theme.fonts.text};
    font-weight: ${theme.fonts.textWeight};
    color: ${theme.colors.text};
  `}
`

export const InfoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
`
